import _ from 'lodash'

import { LOAD_REALESTATES_ESTATES_DISTRIBUTION_DATA_TABLE, DATA_TABLE_REQUEST } from './constants'

import config from '../../../../../../../../../../../config'

export function loadDataTable(id, sorting) {
    return {
        type: LOAD_REALESTATES_ESTATES_DISTRIBUTION_DATA_TABLE,
        data: {
            id,
            sorting,
        },
    }
}

export function loadDataTableRequest(module, id, blockKey, qs) {
    const tableConfig = _.get(config, `api.${module}.${blockKey}.table`, {})

    return {
        type: DATA_TABLE_REQUEST(module, id, blockKey),
        payload: {
            ...tableConfig,
            uriParams: {
                [config.modules[module].blockIdKey]: id,
            },
            qs,
        },
    }
}
